<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item label="发表时间：" class="m-l-14">
      <el-date-picker
        style="width: 260px"
        v-model="filters.dateTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        unlink-panels
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option
          v-for="(item, i) in onlineStatusAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.articleType"
        placeholder="文章分类"
      >
        <el-option
          v-for="(item, i) in articleTypeAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="文章标题/作者名称"
        class="article-name"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      onlineStatusAttr: [],
      articleTypeAttr: [],
    };
  },
  created() {
    this.getSysParamByTypes(["ONLINE_STATUS", "ARTICLE_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["ARTICLE_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.onlineStatusAttr = res.data["ONLINE_STATUS"];
        this.articleTypeAttr = res.data["ARTICLE_TYPE"];
      });
    },
    initData() {
      let params = Object.assign({}, this.filters);
      delete params.dateTime;
      if (this.filters.dateTime) {
        params["startDate"] = this.filters.dateTime[0];
        params["endDate"] = this.filters.dateTime[1];
      }
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
.article-name {
  margin-left: 14px;
  width: 225px;
}
</style>
